import { Navigate, Outlet } from "react-router-dom";
import { constants } from "../utilities/constants";

const PrivateRoute = ({ isAuthenticatedUser }) => {
  return isAuthenticatedUser ? <Outlet /> : <Navigate to={constants.paths.TO_LOGIN} />;
};

export default PrivateRoute;
